import classNames from 'classnames';
import { PreloaderPolygon } from 'components/Preloader';
import React from 'react';

import { Avatar, Space } from '@sravni/react-design-system';

import styles from './logobox.module.scss';

interface IPreloaderItem {
  isSecondLine: boolean;
}

export const PreloaderItem: React.FC<IPreloaderItem> = ({ isSecondLine }) => {
  return (
    <div className={classNames(styles.item, isSecondLine && styles['item--second-line'], styles.preloader)}>
      <Avatar size={44} />
      <div className={styles.item__info}>
        <PreloaderPolygon style={{ width: '120px' }} />
        <Space align={'center'} className={'h-mt-4'}>
          <PreloaderPolygon style={{ width: '40px' }} />
          <PreloaderPolygon style={{ width: '60px', marginLeft: '4px' }} />
        </Space>
      </div>
    </div>
  );
};
